import React, { useState, useEffect } from "react";
import { getLanguage } from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import "./Stagelife.css";
import icon1 from "./assets/home_icons/Home Page_website-07.png";
import icon2 from "./assets/home_icons/Home Page_website-08.png";
import icon3 from "./assets/home_icons/Home Page_website-09.png";
import icon4 from "./assets/home_icons/Home Page_website-10.png";
import icon5 from "./assets/home_icons/Home Page_website-11.png";

const translationData = { en: en, mr: ma };

const Stagelife = () => {
  const [language, setLanguage] = useState(() => getLanguage() || 'en');

  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };

  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', checkLang);
    };
  }, []);

  const stages = [
    { id: 1, icon: icon1, titleKey: "stagelife_stage1_title", subtitleKey: "stagelife_stage1_subtitle" },
    { id: 2, icon: icon2, titleKey: "stagelife_stage2_title", subtitleKey: "stagelife_stage2_subtitle" },
    { id: 3, icon: icon3, titleKey: "stagelife_stage3_title", subtitleKey: "stagelife_stage3_subtitle" },
    { id: 4, icon: icon4, titleKey: "stagelife_stage4_title", subtitleKey: "stagelife_stage4_subtitle" },
    { id: 5, icon: icon5, titleKey: "stagelife_stage5_title", subtitleKey: "stagelife_stage5_subtitle" },
  ];

  return (
    <div className="stagelife-container container mt-5 mb-5">
      <h1 className="stagelife-title">{t('stagelife_title')}</h1>

      <div className="stagelife-content">
        {/* Icons Row */}
        <div className="stages-icons-row">
          {stages.map((stage) => (
            <div key={stage.id} className="stage-icon-wrapper">
              <img
                src={stage.icon}
                alt={stage.title}
                className="stage-icon"
              />
            </div>
          ))}
        </div>

        {/* Line with Bullet Points */}
        <div className="stagelife-timeline">
          <div className="timeline-bullets">
            {stages.map((stage) => (
              <div key={stage.id} className="stage-icon-wrapper">
                <div className="timeline-bullet"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Text Row */}
        <div className="stages-text-row">
          {stages.map((stage) => (
            <div key={stage.id} className="stage-text-wrapper">
              <h3 className="stage-title">{t(stage.titleKey)}</h3>
              <p className="stage-subtitle">{t(stage.subtitleKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stagelife;
